import RadioButton from '@/features/ui/inputs/components/RadioButton'
import { CancelOrderReason } from '@/types/cancelOrder'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface CancelOrderDialogReasonRadioButtonsProps {
    disabled?: boolean
    reason: CancelOrderReason
    onReasonChange: (reason: CancelOrderReason) => void
}

const CancelOrderDialogReasonRadioButtons: FC<CancelOrderDialogReasonRadioButtonsProps> = ({
    disabled,
    reason,
    onReasonChange,
}) => {
    const { t } = useTranslation()

    return (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
            <RadioButton
                disabled={disabled}
                label={t('order.detail.cancelDialog.customerReason')}
                checked={reason === 'customer'}
                value="customer"
                onPress={onReasonChange}
            />
            <RadioButton
                disabled={disabled}
                label={t('order.detail.cancelDialog.restaurantReason')}
                checked={reason === 'restaurant'}
                value="restaurant"
                onPress={onReasonChange}
            />
        </View>
    )
}

export default CancelOrderDialogReasonRadioButtons
